import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useSubscriptionHandler } from "../SubscriptionHandler";

export default function PaymentButton({ isMobile, price }) {
  const { sendSubscription } = useSubscriptionHandler();

  return (
    <PayPalScriptProvider
      options={{
        "client-id": "ATlBkjt07CYDA3fTkjZTZDMt578vKkgzvWit5EaQO7vCwWJ89zN1zr3KQTJ4mFk-3jeFC3De1XCZGVhH",
        currency: "EUR"
      }}
    >
      <PayPalButtons
        style={{
          layout: "horizontal",
          color: "blue",
          shape: "rect",
          tagline: false,
          borderRadius: 8,
          height: isMobile ? 35 : 45
        }}
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: price.toFixed(2), // Es. "18.00"
                  currency_code: "EUR"
                },
                description: "Abbonamento Pro mensile"
              }
            ]
          });
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then(function (details) {
            sendSubscription(details);
          });
        }}
      />
    </PayPalScriptProvider>
  );
}